// src/components/MultipleBarChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register necessary components with Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MultipleBarChart2 = () => {
    // Chart data
    const data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [12, 19, 3, 5, 2, 3, 7],
                backgroundColor: 'rgba(250, 125, 110, 1)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 0,
            },
            {
                label: 'Dataset 2',
                data: [8, 15, 5, 8, 12, 6, 9],
                backgroundColor: 'rgba(135, 205, 235, 1)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 0,
            },
            {
                label: 'Dataset 2',
                data: [8, 1, 50, 8, 12, 6, 9],
                backgroundColor: 'rgba(140, 235, 140, 1)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 0,
            },
        ],
    };

    // Chart options
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top' as const,
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => `Sales: ${tooltipItem.raw}`,
                },
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    autoSkip: false,
                    maxRotation: 90,
                    minRotation: 45,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <div>
            <Bar height={210} data={data} options={options} />
        </div>
    );
};

export default MultipleBarChart2;
